<template>
	<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; z-index: 2000">
		<div style="width: 500px">
			<div class="dialog-header">
				<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{
					project ? $t("edit-project") : $t("new-project")
				}}</span>
				<div style="margin-left: auto; margin-right: 0">
					<md-button @click="$emit('close', false)" class="md-icon-button" style="margin-right: -5px">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>

			<div class="dialog-body">
				<div class="container">
					<span>{{ $t("name") | capitalize }}</span>
					<el-input v-model="newName" :placeholder="$t('new-name')" />
				</div>

				<p style="color: #f44336; margin-top: 10px" v-if="insertError">{{ insertError }}</p>
			</div>

			<div class="dialog-footer" style="width: 100%">
				<div style="margin-left: auto; margin-right: 0">
					<md-button class="cancel" @click="$emit('close', false)">
						{{ $t("cancel") }}
					</md-button>
					<md-button class="add" @click="save">
						<i class="el-icon-loading" v-if="loading" />
						<span>{{ project ? $t("rename") : $t("save") }}</span>
					</md-button>
				</div>
			</div>
		</div>
	</md-dialog>
</template>

<script>
import axios from "axios"
import { filters } from "@/utils/utils"

export default {
	name: "add-edit-project",
	mixins: [filters],
	props: ["project", "show"],
	data() {
		return {
			newName: "",
			insertError: null,
			loading: false
		}
	},
	watch: {
		show() {
			this.loading = false
			this.newName = this.project ? this.project.name : ""
		}
	},
	methods: {
		save() {
			if (!this.newName) {
				this.insertError = this.$t("projects-newname")
			} else {
				this.loading = true
				const url = this.project
					? `${process.env.VUE_APP_API_URL}/api/projects/edit`
					: `${process.env.VUE_APP_API_URL}/api/projects/add`
				const payload = {
					name: this.newName,
					id: this.project ? this.project.id : undefined,
					organization_id: this.$route.params.school_id
				}

				axios
					.post(url, payload, { headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } })
					.then(() => {
						this.insertError = null
						this.newName = ""
						this.loading = false
						this.$notification("success", this.$t("save-successful"), "")
						this.$emit("close", payload)
					})
					.catch(err => {
						this.$processError(this.$t("save-error"), err.response.data.Message)
					})
			}
		}
	}
}
</script>

<style scoped></style>
